module.exports = __webpack_public_path__ + "pcstatic/img/book4.f4c8862.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book4.png
// module id = m1WV
// module chunks = 34